import { useQuery } from '@hooks/reactQuery';

import { getVesEventRawDataById } from '@api/vesEvents';

import { extractQueryParams } from '@utils/common';

import { VES_EVENTS } from '@constants/queryKeys';

interface IQueryVesDataById {
	id?: string;
}

export const useQueryVesRawDataById = (params: IQueryVesDataById) => {
	const { id } = params;

	const { data } = useQuery({
		queryKey: [VES_EVENTS, id],
		queryFn: extractQueryParams(getVesEventRawDataById),
		enabled: [!!id],
	});

	return {
		vesEventRawData: data?.rawData || '',
	};
};
